import Vue from 'vue';
import vuexI18n from 'vuex-i18n';
import store from './store';

const defaultLanguage = 'en';

Vue.use(vuexI18n.plugin, store);

Vue.i18n.fallback(defaultLanguage);

const setInitLanguage = () => {
  if (localStorage.language === 'en' || localStorage.language === 'cg') {
    Vue.i18n.set(localStorage.language);
  } else {
    Vue.i18n.set(defaultLanguage);
    localStorage.setItem('language', defaultLanguage);
  }
};

setInitLanguage();
